import type { LucideIcon } from "lucide-react";
import {
  Apple,
  Beef,
  Cookie,
  CupSoda,
  Droplet,
  Egg,
  Fish,
  Milk,
  Pizza,
  Utensils,
  Wheat,
} from "lucide-react";

import type { ReadonlyRecord } from "@core/foundation/types";

import type { Glyph } from "@apis/calorie-grid/models";

export const GLYPH_ICONS: ReadonlyRecord<Glyph, LucideIcon> = {
  "apple": Apple,
  "beef": Beef,
  "cookie": Cookie,
  "cup-soda": CupSoda,
  "droplet": Droplet,
  "egg": Egg,
  "fish": Fish,
  "milk": Milk,
  "pizza": Pizza,
  "utensils": Utensils,
  "wheat": Wheat,
};
